import { formatMoney, pickLocalized, type LocalizedText, type Tiyin } from '@cr/shared';
import { currentLocale } from './i18n';

/** Суммы приходят в тийинах — наружу показываем сумы. */
export function money(tiyin: Tiyin | null | undefined): string {
  if (tiyin === null || tiyin === undefined) return '—';
  return formatMoney(tiyin, currentLocale());
}

/** Компактно для карточек: 150 000 → 150к */
export function moneyShort(tiyin: Tiyin): string {
  const sum = tiyin / 100;
  return sum >= 1000 ? `${Math.round(sum / 1000)}к` : String(sum);
}

export function localized(text: LocalizedText | null | undefined): string {
  return pickLocalized(text, currentLocale());
}

const MONTHS_SHORT: Record<string, string[]> = {
  ru: ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
  uz: ['yan', 'fev', 'mar', 'apr', 'may', 'iyn', 'iyl', 'avg', 'sen', 'okt', 'noy', 'dek'],
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
};

/** `2026-09-10` → `10 сен` */
export function shortDate(dateOnly: string): string {
  const [, month, day] = dateOnly.split('-');
  const months = MONTHS_SHORT[currentLocale()] ?? MONTHS_SHORT['ru']!;
  return `${Number(day)} ${months[Number(month) - 1]}`;
}

export function dateRange(from: string, to: string): string {
  return from === to ? shortDate(from) : `${shortDate(from)} — ${shortDate(to)}`;
}
